export const constant = (value: string) => value.toUpperCase();
export const camel = (value: string) => value.toLowerCase().replace(/_([a-z0-9])/g, (_, char: string) => char.toUpperCase());
